import { Form } from "react-bootstrap";
import "./index.scss";

export default function SelectForm({
  options = [""],
  value = "null",
  classNames = "",
  name = "",
  disabled = false,
  onChangeFunction = () => {},
}) {
  return (
    <>
      <Form.Select
        disabled={disabled}
        className={classNames}
        value={value}
        onChange={(e) => {
          onChangeFunction(e.target.value, name);
        }}
      >
        {options.map((op, index) => (
          <option
            disabled={op?.disabled === true}
            key={index}
            value={op?.value ?? op} // Make sure the value is properly assigned
          >
            {op?.name ?? op} 
          </option>
        ))}
      </Form.Select>
    </>
  );
}
